"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_iris__scanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1d63cd33-c290-45cb-aa51-24f205acdf9d",
    x1: 95.6,
    y1: 68.67,
    x2: 95.6,
    y2: 166.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#666",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#666",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "iris-scanner-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "895777da-e03e-4839-8a78-8e0ad780f32f",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "52 28 28 28 28 52",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,53.67a4,4,0,0,1-4-4V52a4,4,0,0,0,8,0V49.67A4,4,0,0,1,28,53.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,29.67H32V32H52a4,4,0,0,0,4-4,4.09,4.09,0,0,0-.19-1.17A4,4,0,0,1,52,29.67Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "28 140 28 164 52 164",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,165.83H28a4,4,0,0,1-4-4V164a4,4,0,0,0,4,4H52a4,4,0,0,0,4-4,3.81,3.81,0,0,0-.17-1.08A4,4,0,0,1,52,165.83Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "140 28 164 28 164 52",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,53.67a4,4,0,0,0,4-4V52a4,4,0,0,1-8,0V49.67A4,4,0,0,0,164,53.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,29.67h20V32H140a4,4,0,0,1-4-4,4.09,4.09,0,0,1,.19-1.17A4,4,0,0,0,140,29.67Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "164 140 164 164 140 164",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,165.83h24a4,4,0,0,0,4-4V164a4,4,0,0,1-4,4H140a4,4,0,0,1-4-4,3.81,3.81,0,0,1,.17-1.08A4,4,0,0,0,140,165.83Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "30074429-04f9-4687-a829-072bba36d855",
    "data-name": "9b7af19c-57c6-4b30-83f2-a0593da92088",
    d: "M95.6,143c-46.07,0-66.9-42.95-67.7-44.93a5.49,5.49,0,0,1,0-3.58c.8-1.6,21.63-44.55,67.7-44.55s66.91,43,67.71,44.93a5.62,5.62,0,0,1,0,3.58C162.51,100.05,141.68,143,95.6,143Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.51,141c-33,0-53.36-21.12-62.84-34.43C41.27,119.63,61.52,143,95.51,143c34.24,0,54.53-23.72,63-36.56C149.14,119.59,128.76,141,95.51,141Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "96c2692e-5fb3-4d37-94d1-c97aa6ada988",
    "data-name": "85cdf7db-2a26-416b-a1ca-d38b97548ce9",
    d: "M95.6,124a27.88,27.88,0,1,1,.24,0Z",
    fill: "url(#1d63cd33-c290-45cb-aa51-24f205acdf9d)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.6,
    cy: 96,
    r: 16,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.6,110A16,16,0,0,1,79.65,95c0,.33-.05.66-.05,1a16,16,0,0,0,32,0c0-.34,0-.67,0-1A16,16,0,0,1,95.6,110Z",
    fill: "#4a4d4e"
  })))));
}

var _default = ic_iris__scanner;
exports.default = _default;